import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '@app/services/User/user.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-verify',
  templateUrl: './verify.component.html',
  styleUrls: ['./verify.component.css']
})
export class VerifyComponent implements OnInit {
  email: any;
  id: any;
  constructor(
    private userService: UserService,
    private route: ActivatedRoute, 
  ) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      debugger
      this.email = params['email'];
      this.id = params['id'];
    });
    this.verifyEmail();
  }
  
  verifyEmail() {
    this.userService.verifyEmail(this.id, this.email).subscribe(
      {
        next: (res: any) => {
          if (res.success !== 0) {
            Swal.fire({
              title: res.message,
              icon: "success",
              showConfirmButton: false,
              timer: 1000
            });

          } else {
            Swal.fire({
              title: res.message,
              icon: "error",
              showConfirmButton: false,
              timer: 1500
            });
          }
        },
        error: (err: any) => {
          console.log(err)
        }
      }
    )
  }

}
